import { QueryClient } from '@tanstack/react-query';

import { clientApi } from './axios';
import { ReactQueryBuilder } from '../lib/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      gcTime: 60000, // 1 min
      retryDelay: 300,
      staleTime: 10000, // 10 sec
      refetchOnReconnect: true,
      refetchOnWindowFocus: true,
    },
  },
});

export const { usePost, useFetch, usePatch, useDelete, useUpdate, useLoadMore, usePrefetch } = new ReactQueryBuilder(
  clientApi,
);
